export default __webpack_public_path__ + "static/media/bottomLeft.2e55dcc6.svg";